// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3z7Es","bigColWidth":"Table_bigColWidth__3WFFI","biggerColWidth":"Table_biggerColWidth__1GPxC","row":"Table_row__4upNr","col":"Table_col__2yUmd"};